// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import SpinePlayer from '../../../../components/SpinePlayer';
import theme from '../../../../styled-components/dark';
import { SpineAnimationIds } from '../../../../types/animations';
import { SoundIds } from '../../../../types/sounds';
import { KLVotesAgainstUserCounterIcon } from '../../assets/img';

import KLCounter from './KLCounter';

const Wrapper = styled.div`
  flex: 1;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

const StyledVotesAgainstUserCounter = styled(KLCounter)`
  align-self: flex-end;
  font-size: 1.5em;
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SpinePlayerWrapper = styled.div`
  width: 100%;
  margin-top: -3em;
  padding-bottom: 80%;
`;

const StyledSpinerPlayer = styled(SpinePlayer)`
  left: 1em;
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Text = styled.div`
  font-size: 1.3em;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;

  opacity: 0;
  animation: ${fadeInAnimation} 1s ease 1.5s;
  animation-fill-mode: forwards;
`;

const StyledVotesAgainstIcon = styled.img`
  position: absolute;
  width: 110%;
  left: -60%;
`;

const getColorFromVotes = (votes: number, hasCollar?: boolean) => {
  if (votes === 5) {
    return theme.KLCounter.colorWarning;
  }
  if (votes > 5) {
    if (hasCollar) {
      return theme.KLCounter.colorWarning;
    }
    return theme.KLCounter.colorFatal;
  }
  return theme.KLCounter.color;
};

type KLNotificationVoteProps = {
  votes: number;
  hasCollar?: boolean;
};

const KLNotificationVote = ({ votes, hasCollar }: KLNotificationVoteProps) => {
  const previousVotes = useMemo(() => (votes > 0 ? votes - 1 : 0), [votes]);

  const [votesAgainstProps, setVotesAgainstProps] = useState({
    counter: previousVotes,
    color: getColorFromVotes(previousVotes, hasCollar),
  });

  const onStartAnimation = useCallback(() => {
    setTimeout(() => {
      setVotesAgainstProps({
        counter: votes,
        color: getColorFromVotes(votes, hasCollar),
      });
    }, 1000);
  }, [votes, hasCollar]);

  const VotesAgainstIcon = useMemo(
    // eslint-disable-next-line react/display-name
    () => () => <StyledVotesAgainstIcon src={KLVotesAgainstUserCounterIcon} alt="Number of votes against user" />,
    [],
  );

  const voteSounds = useMemo(() => [SoundIds.KL_VOTE_1, SoundIds.KL_VOTE_2, SoundIds.KL_VOTE_3], []);
  const soundId = useMemo(() => voteSounds[votes % voteSounds.length], [votes, voteSounds]);

  return (
    <Wrapper>
      <StyledVotesAgainstUserCounter {...votesAgainstProps} Icon={VotesAgainstIcon} withTransition />
      <ContentWrapper>
        <SpinePlayerWrapper>
          <StyledSpinerPlayer
            animationId={SpineAnimationIds.KL_VOTE}
            soundId={soundId}
            scale={0.35}
            onStartAnimation={onStartAnimation}
          />
        </SpinePlayerWrapper>
        <Text>Une voix contre vous</Text>
      </ContentWrapper>
    </Wrapper>
  );
};

export default KLNotificationVote;
